import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adaugaTargetareTinte } from "@/api/endpoints/targetareTinte";
import { queryKeys } from "@/lib/queryClient";

export function useAdaugaTargetareTinte() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: adaugaTargetareTinte,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.tinte() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.activitate(),
      });
    },
  });
}
